import { render } from "./OEMswiper.vue?vue&type=template&id=6c2958a4"
import script from "./OEMswiper.vue?vue&type=script&lang=js"
export * from "./OEMswiper.vue?vue&type=script&lang=js"

import "./OEMswiper.vue?vue&type=style&index=0&id=6c2958a4&lang=css"
script.render = render

export default script